import { ArrowDownward, ArrowUpward } from '@mui/icons-material';
import { Alert, Avatar, Button, Card, Chip, Snackbar, Table, Typography } from '@mui/joy';
import { Report } from '@mui/icons-material';
import React, { useEffect, useRef, useState } from 'react';
import { useAuth } from '../context/authContext';
import LoadingSpinnerComponent from '../components/LoadingSpinnerComponent';

const networking = require('../Networking/Benchmarks/benchmarkAPI');
const globalNetworking = require('../Networking/API');
const helper = require('../Helpers/helpers');

function BenchmarkPage({ subscription, app }: any) {
    const { token } = useAuth();

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [showError, setShowError] = useState(false);
    const [data, setData] = useState([]);
    const [sentimentScore, setSentimentScore] = useState('0');

    const hasFetched = useRef(false);

    useEffect(() => {
        if (!hasFetched.current) {
            getBenchmarkData();
            hasFetched.current = true;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function getBenchmarkData() {
        setLoading(true);
        networking.getAppBenchmarkList(app.id).then((data: any) => {
            getReviews(data);
        }).catch((error: Error) => {
            setError(error.message);
            setLoading(false);
        });
    }

    function getReviews(data: any) {
        globalNetworking.reviewsFor(app.id, token).then((reviews: any) => {
            const badReviews = reviews.filter((d: any) => d.sentiment === 'bad').length;
            const goodReviews = reviews.filter((d: any) => d.sentiment === 'good').length;

            const total = reviews.length;

            const badPercentage = badReviews / total;
            const goodPercentage = goodReviews / total;

            const sentimentValue = (goodPercentage * 100 - badPercentage * 100) / 100;

            // If you want to represent it as a percentage score:
            const sentimentPercentage = (sentimentValue + 1) * 50;
            setSentimentScore(sentimentPercentage.toFixed(0));

            setData(data.data.benchmark);
            setLoading(false);
        }).catch((error: Error) => {
            setError(error.message);
            setLoading(false);
        });
    }

    return (
        <div>
            {showError &&
                <Snackbar
                    variant="soft"
                    color="danger"
                    open={showError}
                    onClose={() => setShowError(false)}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    startDecorator={<Report />}
                    endDecorator={
                        <Button
                            onClick={() => setShowError(false)}
                            size="sm"
                            variant="soft"
                            color="danger"
                        >
                            Dismiss
                        </Button>
                    }
                >
                    {error}
                </Snackbar>
            }
            <Alert
                className="mb-3"
                size="lg"
                variant="soft"
                color="neutral"
            >
                <div>
                    <div>
                        <Typography
                            level="title-md">
                            Benchmarks
                        </Typography>
                    </div>
                    <Typography
                        level="body-sm">
                        Compare your app’s performance against competitors, identifying strengths
                        and areas for improvement with real data.
                    </Typography>
                </div>
            </Alert>
            {loading ?
                <LoadingSpinnerComponent />
                :
                <>
                    {data &&
                        <div className='row gx-4'>
                            {app && app.appleappid &&
                                <div className='col'>
                                    <Card
                                        variant="outlined"
                                        color='neutral'
                                        sx={{
                                            backgroundColor: 'white'
                                        }}>
                                        <Table stickyHeader>
                                            <thead style={{ backgroundColor: '#f9f9f9' }}>
                                                <tr>
                                                    <td style={{ width: '80px', padding: '16px' }}>
                                                        <Typography
                                                            fontWeight={700}
                                                            level='body-sm'>
                                                            App
                                                        </Typography>
                                                    </td>
                                                    <td>

                                                    </td>
                                                    <td>
                                                        <Typography
                                                            fontWeight={700}
                                                            level='body-sm'>
                                                            Genre
                                                        </Typography>
                                                    </td>
                                                    <td>
                                                        <Typography
                                                            fontWeight={700}
                                                            level='body-sm'>
                                                            Store
                                                        </Typography>
                                                    </td>
                                                    <td>
                                                        <Typography
                                                            fontWeight={700}
                                                            level='body-sm'>
                                                            # ratings
                                                        </Typography>
                                                    </td>
                                                    <td>
                                                        <Typography
                                                            fontWeight={700}
                                                            level='body-sm'>
                                                            Avg. rating
                                                        </Typography>
                                                    </td>
                                                    <td>
                                                        <Typography
                                                            fontWeight={700}
                                                            level='body-sm'>
                                                            Sentiment meter
                                                        </Typography>
                                                    </td>
                                                </tr>
                                            </thead>
                                            <thead style={{ backgroundColor: '#f9f9f9' }}>
                                                <tr>
                                                    <td style={{ width: '80px', padding: '16px' }}>
                                                        <Avatar
                                                            alt={app.name + 'App icon'}
                                                            src={app.icon}>
                                                            {helper.getInitials(app.name)}
                                                        </Avatar>
                                                    </td>
                                                    <td>
                                                        {app.name}
                                                    </td>
                                                    <td>
                                                        {app.apple_genres.join(', ')}
                                                    </td>
                                                    <td>
                                                        {helper.iconFor('applestore')}
                                                    </td>
                                                    <td>
                                                        {app.apple_rating_count}
                                                    </td>
                                                    <td>
                                                        {app.apple_rating_value}
                                                    </td>
                                                    <td>
                                                        <Chip
                                                            sx={{ marginLeft: '5px' }}
                                                            size='sm'
                                                            color='primary'>
                                                            {sentimentScore}
                                                        </Chip>
                                                    </td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data && data.filter((app: any) => app.store === 'applestore').map((benchmark: any, index: number) => (
                                                    <tr key={index} >
                                                        <td style={{ whiteSpace: 'nowrap', padding: '16px' }}>
                                                            <Avatar
                                                                alt={benchmark.name + 'App icon'}
                                                                src={benchmark.icon}>
                                                                {helper.getInitials(benchmark.name)}
                                                            </Avatar>
                                                        </td>
                                                        <td>
                                                            {benchmark.name}
                                                        </td>
                                                        <td>
                                                            {benchmark.genre.join(', ')}
                                                        </td>
                                                        <td>
                                                            {helper.iconFor(benchmark.store)}
                                                        </td>
                                                        <td>
                                                            {benchmark.ratings_count}
                                                            <span>
                                                                <Chip
                                                                    sx={{ marginLeft: '5px' }}
                                                                    size='sm'
                                                                    color={app.apple_rating_count > benchmark.ratings_count ? 'success' : 'danger'}>
                                                                    {app.apple_rating_count > benchmark.ratings_count ?
                                                                        <ArrowUpward sx={{ width: '14px' }} /> :
                                                                        <ArrowDownward sx={{ width: '14px' }} />}
                                                                </Chip>
                                                            </span>
                                                        </td>
                                                        <td>
                                                            {benchmark.avg_rating.toFixed(2)}
                                                            <span>
                                                                <Chip
                                                                    sx={{ marginLeft: '5px' }}
                                                                    size='sm'
                                                                    color={app.apple_rating_value > benchmark.avg_rating ? 'success' : 'danger'}>
                                                                    {app.apple_rating_value > benchmark.avg_rating ?
                                                                        <ArrowUpward sx={{ width: '14px' }} /> :
                                                                        <ArrowDownward sx={{ width: '14px' }} />}
                                                                </Chip>
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <Chip
                                                                sx={{ marginLeft: '5px' }}
                                                                size='sm'
                                                                color='primary'>
                                                                {benchmark.sentiment_score}
                                                            </Chip>
                                                            <span>
                                                                <Chip
                                                                    sx={{ marginLeft: '5px' }}
                                                                    size='sm'
                                                                    color={sentimentScore > benchmark.sentiment_score ? 'success' : 'danger'}>
                                                                    {sentimentScore > benchmark.sentiment_score ?
                                                                        <ArrowUpward sx={{ width: '14px' }} /> :
                                                                        <ArrowDownward sx={{ width: '14px' }} />}
                                                                </Chip>
                                                            </span>
                                                        </td>
                                                    </tr>
                                                ))
                                                }
                                            </tbody>
                                        </Table>
                                    </Card>
                                </div>
                            }

                            {app && app.androidpackageid &&
                                <div className='col'>
                                    <Card
                                        variant="outlined"
                                        color='neutral'
                                        sx={{
                                            backgroundColor: 'white'
                                        }}>
                                        <Table stickyHeader>
                                            <thead style={{ backgroundColor: '#f9f9f9' }}>
                                                <tr>
                                                    <td style={{ width: '80px', padding: '16px' }}>
                                                        <Typography
                                                            fontWeight={700}
                                                            level='body-sm'>
                                                            App
                                                        </Typography>
                                                    </td>
                                                    <td>

                                                    </td>
                                                    <td>
                                                        <Typography
                                                            fontWeight={700}
                                                            level='body-sm'>
                                                            Genre
                                                        </Typography>
                                                    </td>
                                                    <td>
                                                        <Typography
                                                            fontWeight={700}
                                                            level='body-sm'>
                                                            Store
                                                        </Typography>
                                                    </td>
                                                    <td>
                                                        <Typography
                                                            fontWeight={700}
                                                            level='body-sm'>
                                                            # ratings
                                                        </Typography>
                                                    </td>
                                                    <td>
                                                        <Typography
                                                            fontWeight={700}
                                                            level='body-sm'>
                                                            Avg. rating
                                                        </Typography>
                                                    </td>
                                                    <td>
                                                        <Typography
                                                            fontWeight={700}
                                                            level='body-sm'>
                                                            Sentiment meter
                                                        </Typography>
                                                    </td>
                                                </tr>
                                            </thead>
                                            <thead style={{ backgroundColor: '#f9f9f9' }}>
                                                <tr>
                                                    <td style={{ width: '80px', padding: '16px' }}>
                                                        <Avatar
                                                            alt={app.name + 'App icon'}
                                                            src={app.icon}>
                                                            {helper.getInitials(app.name)}
                                                        </Avatar>
                                                    </td>
                                                    <td>
                                                        {app.name}
                                                    </td>
                                                    <td>
                                                        {app.google_genres}
                                                    </td>
                                                    <td>
                                                        {helper.iconFor('playstore')}
                                                    </td>
                                                    <td>
                                                        {app.google_rating_count}
                                                    </td>
                                                    <td>
                                                        {app.google_rating_value}
                                                    </td>
                                                    <td>
                                                        <Chip
                                                            sx={{ marginLeft: '5px' }}
                                                            size='sm'
                                                            color='primary'>
                                                            {sentimentScore}
                                                        </Chip>

                                                    </td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data && data.filter((app: any) => app.store === 'playstore').map((benchmark: any, index: number) => (
                                                    <tr key={index} >
                                                        <td style={{ whiteSpace: 'nowrap', padding: '16px' }}>
                                                            <Avatar
                                                                alt={benchmark.name + 'App icon'}
                                                                src={benchmark.icon}>
                                                                {helper.getInitials(benchmark.name)}
                                                            </Avatar>
                                                        </td>
                                                        <td>
                                                            {benchmark.name}
                                                        </td>
                                                        <td>
                                                            {benchmark.genre}
                                                        </td>
                                                        <td>
                                                            {helper.iconFor(benchmark.store)}
                                                        </td>
                                                        <td>
                                                            {benchmark.ratings_count}
                                                            <span>
                                                                <Chip
                                                                    sx={{ marginLeft: '5px' }}
                                                                    size='sm'
                                                                    color={app.google_rating_count > benchmark.ratings_count ? 'success' : 'danger'}>
                                                                    {app.google_rating_count > benchmark.ratings_count ?
                                                                        <ArrowUpward sx={{ width: '14px' }} /> :
                                                                        <ArrowDownward sx={{ width: '14px' }} />}
                                                                </Chip>
                                                            </span>
                                                        </td>
                                                        <td>
                                                            {benchmark.avg_rating && benchmark.avg_rating.toFixed(2)}
                                                            <span>
                                                                <Chip
                                                                    sx={{ marginLeft: '5px' }}
                                                                    size='sm'
                                                                    color={app.google_rating_value > benchmark.avg_rating ? 'success' : 'danger'}>
                                                                    {app.apple_rating_value > benchmark.avg_rating ?
                                                                        <ArrowUpward sx={{ width: '14px' }} /> :
                                                                        <ArrowDownward sx={{ width: '14px' }} />}
                                                                </Chip>
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <Chip
                                                                sx={{ marginLeft: '5px' }}
                                                                size='sm'
                                                                color='primary'>
                                                                {benchmark.sentiment_score}
                                                            </Chip>
                                                            <span>
                                                                <Chip
                                                                    sx={{ marginLeft: '5px' }}
                                                                    size='sm'
                                                                    color={sentimentScore > benchmark.sentiment_score ? 'success' : 'danger'}>
                                                                    {sentimentScore > benchmark.sentiment_score ?
                                                                        <ArrowUpward sx={{ width: '14px' }} /> :
                                                                        <ArrowDownward sx={{ width: '14px' }} />}
                                                                </Chip>
                                                            </span>
                                                        </td>
                                                    </tr>
                                                ))
                                                }
                                            </tbody>
                                        </Table>
                                    </Card>
                                </div>
                            }
                        </div>
                    }
                </>
            }
        </div>
    );
}

export default BenchmarkPage;